enum Status {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PAID = "PAID",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}

const STATUS_OPTIONS = Object.values(Status) as Status[];

interface User {
  id: number;
  email: string;
  name: string | null;
  role: string;
  hasSetupComplete: boolean;
  createdAt: string;
  updatedAt: string;
}

interface Provider {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

interface Address {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

interface AddressProvider {
  id: number;
  addressId: number;
  providerId: number;
  username: string | null;
  password: string | null;
  accountKeyword: string | null;
  skipPayment: boolean;
  taxDeduction: boolean;
  taxDeductionAmount: number | null;
  meterReadingEnabled: boolean;
  invoiceEmailTo: string | null;
  createdAt: string;
  updatedAt: string;
  address: Address;
  provider: Provider;
}

interface Invoice {
  id: number;
  addressProviderId: number;
  invoiceDate: string;
  status: Status;
  datePaid: string | null;
  fileKey: string | null;
  amount: number | null;
  reference: string | null;
  account: string | null;
  address: string | null;
  createdAt: string;
  updatedAt: string;
  addressProvider: AddressProvider;
}

interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface ApiError {
  status: number;
  message: string;
  details?: Record<string, unknown>;
}

interface AddressWithProviders extends Address {
  providers: AddressProvider[];
}

interface AddressWithOptionalProviders extends Address {
  providers?: AddressProvider[];
}

type AddressData = AddressWithProviders & {
  addressProviders: AddressProvider[];
};

enum Role {
  ADMIN = "ADMIN",
  USER = "USER",
}

const ROLE_OPTIONS = Object.values(Role) as Role[];

interface SidebarLink {
  to: string;
  labelKey: string;
  icon: string;
  adminOnly?: boolean;
}

export {
  type Address,
  type AddressData,
  type AddressProvider,
  type AddressWithOptionalProviders,
  type AddressWithProviders,
  type ApiError,
  type Invoice,
  type PaginatedResponse,
  type Provider,
  ROLE_OPTIONS,
  Role,
  STATUS_OPTIONS,
  type SidebarLink,
  Status,
  type User,
};
